import { Route, Routes } from 'react-router-dom';

import ViewAppointment from '../components/Appointments/ViewAppointment';
import AppointmentList from '../components/Appointments/AppointmentList';

const Appointments = () => {
  return (
    <Routes>
      <Route path="/" element={<AppointmentList />} />
      <Route path="/view/:id" element={<ViewAppointment />} />
    </Routes>
  )
}

export default Appointments;